import * as React from "react";
import { Modal, Card, Input } from "antd";

const { TextArea } = Input;

type Props = {
  status: boolean;
  onCancel: () => void;
  messageData: string;
  isHtml?: boolean;
};

export const PreviewModal: React.FC<Props> = ({ status, onCancel, messageData, isHtml = false }) => {
  if (!status) return null;

  return (
    <Modal width={800} open={status} footer={null} onCancel={onCancel}>
      <Card title="Preview Message">
        {isHtml ? (
          <div
            style={{
              position: "relative",
              border: "1px solid #e0e0e0",
              borderRadius: "4px",
              padding: "12px",
              maxHeight: "600px",
              overflowY: "auto",
              backgroundColor: "#fafafa",
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: messageData }} />
          </div>
        ) : (
          <TextArea
            rows={7}
            placeholder={"Message"}
            maxLength={20000}
            size="small"
            status=""
            variant="outlined"
            disabled={false}
            readOnly={true}
            value={messageData}
            className="text-dark"
          />
        )}
      </Card>
    </Modal>
  );
};
